module.exports = __webpack_public_path__ + "static/media/raven_funny_03.3d8d7b41.svg";